import ekfcLogo from "../assets/ekfc-logo.png";

import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Link from "@mui/material/Link";
import Alert from "@mui/material/Alert";

import Typography from "@mui/material/Typography";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://www.emiratesflightcatering.com/">
        Emirates Flight Catering
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
const theme = createTheme();

export function SSOLoginForm(props) {
  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        component="main"
        sx={{
          height: "100vh",
        }}
      >
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${ekfcLogo})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundPosition: "center",
          }}
        />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography component="h6" variant="h6" sx={{ mb: 5 }}>
              <strong>Quality Reports - Sample Control Application</strong>
            </Typography>
            <Box
              sx={{
                mt: 1,
              }}
            >
              <Typography component="div">
                You need to be a verified user to access this particular
                application.
              </Typography>
              <Typography component="div">
                Please verify your identity by logging in via your{" "}
                <strong>company provided Microsoft ID</strong>
              </Typography>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={props.handleSubmit}
                sx={{
                  mt: 3,
                  mb: 2,
                }}
              >
                Sign In via SSO
              </Button>
              <Grid container>
                <Grid item>
                  {props.errors && props.errors.email && (
                    <Alert variant="outlined" severity="error">
                      {props.errors.email}
                    </Alert>
                  )}
                  <p>
                    If you don't have an account contact your supervisor for
                    further support.
                  </p>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Copyright
            sx={{
              mt: 5,
            }}
          />
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
